import React, { useEffect, useRef } from "react"
import ModalDialog from "../../../../components/common/ModalDialog";
import { Typography } from "@material-ui/core";

export const DeleteModal = ({ open, onConfirm, onCancel }) => {
    
    const imageModalRef = useRef(null);

    useEffect(() => {
        if (open) handleOpen();
    }, [open])

    const handleOpen = () => {
        imageModalRef.current.handleClickOpen()
    }

    const confirmAndClose = () => {
        onConfirm();
        imageModalRef.current.handleClose()
    }

    return (
        <ModalDialog
            ref={imageModalRef}
            onClose={onCancel}
            onConfirm={confirmAndClose}
            confirmText={"Delete"}
            title={"Marketing Code"}
        >
            <Typography>
                Are you sure you want to delete marketing code?
            </Typography>
        </ModalDialog>
    )
}


// WEBPACK FOOTER //
// ./src/containers/Settings/Shop/ManageReceipt/DeleteModal.js